import { LoyaltySvg } from './assets/LoyaltySvg'

export const data = [
	{
		NAME: `Магазины`,
		LINK: `/shops/`
	},
	{
		NAME: `Доставка и оплата`,
		LINK: `/delivery/`
	},
	{
		NAME: `Сервисные центры`,
		LINK: `/service`,
		targetBlank: false
	},
	{
		NAME: `Для бизнеса`,
		LINK: `/b2b/`
	},

	{
		NAME: `Акции`,
		LINK: `/sales/`
		// ICON: SaleIcon
	},
	{
		NAME: `Подарочная карта`,
		LINK: '/gift'
	},
	{
		NAME: ` Программа лояльности`,
		LINK: `/services/iport-card`,
		ICON: LoyaltySvg
	},
	{
		NAME: `Обмен в Трейд-ин`,
		LINK: `/services/trade-in/`
	}
]
